module.exports = __webpack_public_path__ + "img/mistery.1f590b68.svg";